import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "member-modal"
};
const _hoisted_2 = {
  class: "toolbox"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, "可选成员为未参与任务成员，可进行添加", -1);

const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("确定");

import { ref, computed, watch, nextTick } from 'vue';
import { getVexTableProps } from '@/config';
import { taskNoJoinUser } from '@/request';
export default {
  name: 'member-modal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    params: Object,
    selectedIds: Array
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    watch(() => props.modelValue, v => {
      if (v) {
        var _table$value;

        keyword.value = '';
        selectedList.value = [];
        (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.commitProxy('reload');
      }
    });
    const keyword = ref('');
    const table = ref();
    const tableData = ref([]);
    const tableOptions = getVexTableProps({
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      columns: [{
        type: 'checkbox',
        width: '50px'
      }, {
        title: '登录账号',
        field: 'loginName'
      }, {
        title: '联系人',
        field: 'linkMan'
      }, {
        title: '角色名称',
        field: 'employeeName'
      }, {
        title: '团队',
        field: 'supplierName'
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            taskNoJoinUser(_objectSpread({
              page: page.currentPage,
              pageSize: page.pageSize,
              keyword: keyword.value
            }, props.params)).then(data => {
              tableData.value = data.data;
              res({
                total: data.total,
                result: data.data
              });

              if (selectedList.value.length) {
                setTimeout(() => {
                  let selectedRows = data.data.filter(item => selectedList.value.find(v => v.supUserId == item.supUserId));
                  table.value.setCheckboxRow(selectedRows, true);
                }, 300);
              }
            });
          })
        }
      }
    });

    function checkboxVisibleMethod({
      row
    }) {
      return !props.selectedIds.find(id => row.supUserId == id);
    }

    const selectedList = ref([]);

    function tableSelectHandle(e) {
      console.log('row');
      let {
        row,
        checked
      } = e;
      let findIndex = selectedList.value.findIndex(v => v.supUserId == row.supUserId);

      if (checked && findIndex == -1) {
        selectedList.value.push(row);
      } else {
        selectedList.value.splice(findIndex, 1);
      }
    }

    function tableAllSelectHandle(e) {
      console.log('records');
      let {
        records,
        checked
      } = e;

      if (checked) {
        records.forEach(item => {
          if (selectedList.value.find(v => v.supUserId == item.supUserId)) return;
          selectedList.value.push(item);
        });
      } else {
        tableData.value.forEach(item => {
          let findIndex = selectedList.value.findIndex(v => v.supUserId === item.supUserId);

          if (findIndex > -1) {
            selectedList.value.splice(findIndex, 1);
          }
        });
      }
    }

    function submit() {
      emit('success', selectedList.value);
      visible.value = false;
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "可选成员",
        width: "70%",
        top: "50px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
          modelValue: keyword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => keyword.value = $event),
          placeholder: "请输入登录账号/联系人",
          style: {
            "width": "200px"
          }
        }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = $event => table.value.commitProxy('reload'))
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _hoisted_4]), _unref(visible) ? (_openBlock(), _createBlock(_component_vxe_grid, _mergeProps({
          key: 0,
          ref_key: "table",
          ref: table
        }, _unref(tableOptions), {
          "checkbox-config": {
            checkMethod: checkboxVisibleMethod
          },
          onCheckboxChange: tableSelectHandle,
          onCheckboxAll: tableAllSelectHandle
        }), null, 16, ["checkbox-config"])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};